import cookies from 'js-cookie';
export var byABTestingFactory = function (_a) {
    var abTestingCookieName = _a.abTestingCookieName;
    return function () {
        return cookies.get(abTestingCookieName) === 'TRUE';
    };
};
//# sourceMappingURL=byABTesting.js.map